export default "__VITE_ASSET__CGfUY9SI__"